<template>
    <div class="af-app af-reset-password">
        <ResetPassword />
    </div>
</template>

<script>
    import Cookie from '@/services/cookie';
    import ResetPassword from '@/apps/reset-password/001/components/ResetPassword';

    export default {
        name: 'App',

        components: {
            ResetPassword,
        },

        created() {
            Cookie.deleteToken();
        },
    };
</script>
